'use strict';

/**
 * justHeight
 */
export const justHeight = (() => {
    let winH = 0;
    let navH = 0;
    let headH = 0;
    let navInH = 0;
    let realH = 0;
    let currentWidth = window.innerWidth;

    /**
     * init
     */
    const init = () => {
        adjust();
        adjustTop();
        history.scrollRestoration = "manual";//更新＆戻るの際のスクロール位置リセット

        $(window).on('load resize scroll', function () {
            adjust();
        });

        $(window).on('load resize', function () {
            if (currentWidth !== window.innerWidth) {
                adjustTop();
            }
        });
    };

    const adjust = () => {
        if ($(window).width() <= 768) {
            winH = window.innerHeight;
            navH = winH - $('.js-header').outerHeight();
            $('.js-justH-s').height(navH);

            if (!$('body').hasClass('is-show-message')) {
                $('.js-justH').height(winH);
            }
        } else {
            $('.js-justH-s').height('100%');
            $('.js-justH').height('100%');
        }
    };

    const adjustTop = () => {
        if ($(window).width() <= 768) {
            winH = window.innerHeight;
            $('.js-justH-top').height(winH);
        } else {
            $('.js-justH-top').height('100vh');
        }
    };

    // public
    return {
        init: init
    };
})();
